import { z } from 'zod';
/**
 * Whether a user is a real account or the stub a schedule import creates for a provider it has
 * only seen in EHR data. A provisional user cannot authenticate and is not an eligible principal.
 */
export var UserKind;
(function (UserKind) {
    UserKind["Provisional"] = "PROVISIONAL";
    UserKind["Active"] = "ACTIVE";
})(UserKind || (UserKind = {}));
export const UserKindSchema = z.enum(UserKind);
//# sourceMappingURL=kind.js.map